import { type FC } from 'react';

import {
  AnalyticsInitializer,
  BrowserCommunicator,
  Content,
  FeatureToggler,
  Providers,
  SendbirdContainer,
  ToastsContainer,
  UIStoreSync,
} from './App.constants';

const App: FC = () => (
  <Providers>
    <ToastsContainer />
    <SendbirdContainer />
    <UIStoreSync />
    <AnalyticsInitializer />
    <BrowserCommunicator />
    <FeatureToggler />
    <Content />
  </Providers>
);

export default App;
